
import { useState } from 'react';
import { CartItem, DrinkOption } from '../types';

export function useCart() {
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [isCartOpen, setIsCartOpen] = useState(false);

  const addToCart = (
    drink: DrinkOption,
    milk: 'Whole Milk' | 'Oat Milk',
    temperature: 'Hot' | 'Iced',
    quantity: number,
    flavor?: 'Rose' | 'Lavender'
  ) => {
    const newItem: CartItem = {
      id: `${drink.id}-${milk}-${temperature}-${flavor || ''}-${Date.now()}`,
      drink,
      milk,
      temperature,
      flavor,
      quantity
    };
    
    setCartItems(prev => [...prev, newItem]);
  };

  const removeFromCart = (itemId: string) => {
    setCartItems(prev => prev.filter(item => item.id !== itemId));
  };

  const updateQuantity = (itemId: string, quantity: number) => {
    if (quantity <= 0) {
      removeFromCart(itemId);
      return;
    }
    
    setCartItems(prev =>
      prev.map(item =>
        item.id === itemId ? { ...item, quantity } : item
      )
    );
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const getTotalItems = () => {
    return cartItems.reduce((total, item) => total + item.quantity, 0);
  };

  return {
    cartItems,
    isCartOpen,
    setIsCartOpen,
    addToCart,
    removeFromCart,
    updateQuantity,
    clearCart,
    getTotalItems
  };
}
